export default __webpack_public_path__ + "static/media/touchZero.a66dbc72.svg";